/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react';
import { useGLTF, useAnimations } from '@react-three/drei';

export default function Model(props) {
    const group = useRef();
    const { nodes, materials, animations } = useGLTF('/char.glb');
    const { actions } = useAnimations(animations, group);
    return (
        <group ref={group} {...props} dispose={null}>
            <group
                name="Armature"
                position={[0, -3, 0.69]}
                rotation={[Math.PI / 2, 0, 0]}
                scale={[0.035, 0.035, 0.035]}>
                <primitive object={nodes.mixamorigHips} />
                <skinnedMesh
                    geometry={nodes.Ch02_Body.geometry}
                    material={nodes.Ch02_Body.material}
                    skeleton={nodes.Ch02_Body.skeleton}
                />
                <skinnedMesh
                    geometry={nodes.Ch02_Cloth.geometry}
                    material={nodes.Ch02_Cloth.material}
                    skeleton={nodes.Ch02_Cloth.skeleton}
                />
                <skinnedMesh
                    geometry={nodes.Ch02_Eyelashes.geometry}
                    material={nodes.Ch02_Eyelashes.material}
                    skeleton={nodes.Ch02_Eyelashes.skeleton}
                />
                <skinnedMesh
                    geometry={nodes.Ch02_Hair.geometry}
                    material={nodes.Ch02_Hair.material}
                    skeleton={nodes.Ch02_Hair.skeleton}
                />
                <skinnedMesh
                    geometry={nodes.Ch02_Sneakers.geometry}
                    material={nodes.Ch02_Sneakers.material}
                    skeleton={nodes.Ch02_Sneakers.skeleton}
                />
                <skinnedMesh
                    geometry={nodes.Ch02_Socks.geometry}
                    material={nodes.Ch02_Socks.material}
                    skeleton={nodes.Ch02_Socks.skeleton}
                />
            </group>
        </group>
    );
}

useGLTF.preload('/char.glb');
